"use client";

import { useEffect } from "react";

export default function ClientChunkErrorHandler({ children }) {
  useEffect(() => {
    const handler = (event) => {
      const error = event?.error || event?.reason;

      const message =
        event?.message ||
        event?.reason?.message ||
        "Unknown error";

      // ✅ 1. ALWAYS LOG FULL ERROR
      console.error("🔥 Application Error");
      console.error("Message:", message);
      console.error("Error Object:", error);
      console.error("Stack:", error?.stack);

      // ✅ 2. FILE + LINE (VERY IMPORTANT)
      if (event?.filename) {
        console.error("File:", event.filename);
        console.error("Line:", event.lineno);
        console.error("Column:", event.colno);
      }

      // ✅ 3. HANDLE CHUNK ERROR SAFELY (NO LOOP)
      if (message.includes("ChunkLoadError")) {
        console.warn("⚠️ ChunkLoadError detected");

        // prevent infinite reload loop
        if (!sessionStorage.getItem("chunk-reloaded")) {
          sessionStorage.setItem("chunk-reloaded", "true");
          window.location.reload();
        }
      }
    };

    window.addEventListener("error", handler);
    window.addEventListener("unhandledrejection", handler);

    return () => {
      window.removeEventListener("error", handler);
      window.removeEventListener("unhandledrejection", handler);
    };
  }, []);

  return children;
}